module.exports = __webpack_public_path__ + "img/code33.36404a4a.png";